/**
 * Implement pause button listeners for all videos.
 */
(() => {
    function pauseButtonClicked(e) {
        // console.log('Pause button clicked');

        H_Tools.video.togglePauseState(e.target.closest('.js-video'));
    }

    document
        .querySelectorAll('.js-pause-button, .js-pause-button-overlay')
        .forEach((el) => {
            el.addEventListener('click', pauseButtonClicked);
        });
})();
